import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ClientForm from "./ClientForm";
import './index.css';

// Hard redirect component
function RedirectToMainSite() {
  useEffect(() => {
    window.location.href = "https://kineticlaw.co.uk";
  }, []);
  return null;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      {/* Root path (/) redirects to main site */}
      <Route path="/" element={<RedirectToMainSite />} />

      {/* Specific path /client (without slug) should also redirect */}
      <Route path="/client" element={<RedirectToMainSite />} />

      {/* Client form route with slug */}
      <Route path="/client/:slug" element={<ClientForm />} />

      {/* Catch-all route */}
      <Route path="*" element={<RedirectToMainSite />} />
    </Routes>
  </BrowserRouter>
);
